module.exports = __webpack_public_path__ + "static/media/pessoas.c6de6c39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Identidade/pessoas.svg
// module id = 276
// module chunks = 0